var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('DHLReturnShowBlock',{attrs:{"DHLReturn":_vm.DHLReturn}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }